import React from 'react';
export function WhatItDoes() {
  return <section className="py-20 bg-white" data-id="element-2119" data-mp="1rsjgyki25h7c">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg prose-slate" data-id="element-2120" data-mp="281967iqxzzca">
        <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-6 text-center" data-id="element-2121" data-mp="2lsdx9wg8vjb0">
          What IntelliEats Does
        </h2>
        <p data-id="element-2122" data-mp="2h0mfobf2gnx0">
          IntelliEats is a revolutionary{' '}
          <strong data-id="element-2123" data-mp="2vqjyebu88let">food ingredient scanner app</strong> designed to help you
          decode complex nutrition labels in seconds. Have you ever looked at
          the back of a packaged food item and felt completely overwhelmed by
          the long, unpronounceable chemical names? You are not alone. Food
          manufacturers often use complex terminology to disguise everyday
          additives, preservatives, and artificial sweeteners.
        </p>
        <p data-id="element-2124" data-mp="1ae0gfbjws44h">
          What IntelliEats does is act as your personal, pocket-sized digital
          nutritionist. By simply pointing your smartphone camera at any
          ingredient list, our advanced AI-powered text recognition instantly
          scans, reads, and cross-references every single item against a
          comprehensive, research-backed database of food additives.
        </p>
        <p data-id="element-2125" data-mp="3l5ie7zryrpzw">
          Within moments, the app highlights exactly what is inside your food.
          It flags harmful chemicals, identifies hidden sources of sugar and
          sodium, and alerts you to ingredients that conflict with your specific
          dietary restrictions—whether you are vegan, keto, gluten-free, or
          managing nut allergies. Instead of spending twenty minutes in the
          grocery store aisle googling "is maltodextrin safe," IntelliEats gives
          you a clear, color-coded breakdown so you can make an informed,
          confident decision and keep moving.
        </p>
      </div>
    </section>;
}